import { ApiGarGarsListRequest, GAR } from "@nens/brostar/openapi-client";
import { qualityRegimeOptionsType } from "@nens/brostar/uploadapi-client";

import { SearchOption } from "@/components/searchbox";

export const garInformation: SearchOption<keyof GAR, keyof ApiGarGarsListRequest>[] = [
  { key: "broId", searchKey: "broIdIcontains", label: "BRO-ID" },
  { key: "gmwBroId", searchKey: "gmwBroIdIcontains", label: "Put-ID" },
  { key: "tubeNumber", label: "Buisnummer" },
  {
    key: "qualityRegime",
    label: "Kwaliteitsregime",
    enum: qualityRegimeOptionsType.map((option) => ({ key: option, label: option })),
  },
  { key: "samplingDatetime", label: "Bemonsteringsdatum" },
  { key: "qualityControlMethod", label: "Kwaliteitscontrolemethode" },
];
